import { Component, OnInit, afterNextRender } from '@angular/core';

import { AlertMessageService } from '@sigepe/sigepe-template';
import { FeriasBaseComponent } from '../../ferias-base.component';
import { HistoricoTramitacaoProcessoService } from 'src/app/services/historico-tramitacao-processo.service';
import { Router } from '@angular/router';
import { SituacaoExercicioFeriasEnum } from 'src/app/components/shared/enums/situacao-exercicio-ferias.enum';
import { SituacaoParcelaFeriasEnum } from 'src/app/components/shared/enums/situacao-parcela-ferias.enum';
import { TipoFeriasEspecialEnum } from 'src/app/components/shared/enums/tipo-ferias-especial.enum';
import { obterDescricaoPeriodoAquisitivo, PeriodoAquisitivo } from 'src/app/components/shared/models/periodo-aquisitivo';
import { DetalhamentoFeriasEspeciais, ExercicioDetalhadoFeriasEspeciais, ExerciciosService, ExercicioSelecionado, OperacaoFeriasEspeciaisDetalhada } from 'src/app/services/exercicios.service';

type ExercicioSelecionadoNavegacao = ExercicioSelecionado & {
    origemTela?: string;
};

export interface ParcelaFeriasEmExibicao {
    ordem: number;
    geracao: number;
    dataInicio: Date;
    dataFim: Date;
    quantidadeDias: number;
    situacao: {
        //Vindo da enum SituacaoParcelaFeriasEnum
        descricao: string;
        codigoCor: string;
    };
    adiantamentoSalarial: {
        valor: boolean;
    };
    abonoPecuniario: {
        valor: boolean;
    };
    adiantamentoDecimoTerceiro: {
        valor: boolean;
    };
    parcelasDesconto: number;
    dataInterrupcao: Date;
    motivoLegal: string;
    justificativaInterrupcao: string;
    documentoLegal: string;
    dataPublicacaoDocumentoLegal: Date;
    justificativaAcumulo: string;
}

export interface ParcelaFeriasCanceladasEmExibicao {
    dataInicio: Date;
    dataFim: Date;
    quantidadeDias: number;
    situacao: {
        //Vindo da enum SituacaoParcelaFeriasEnum
        descricao: string;
        codigoCor: string;
    };
    adiantamentoSalarial: {
        valor: boolean;
    };
    abonoPecuniario: {
        valor: boolean;
    };
    adiantamentoDecimoTerceiro: {
        valor: boolean;
    };
    parcelasDesconto: number;
    dataInterrupcao: Date;
    motivoLegal: string;
    justificativaInterrupcao: string;
    documentoLegal: string;
    dataPublicacaoDocumentoLegal: Date;
}

@Component({
    selector: 'app-detalhar-ferias',
    templateUrl: './detalhar-ferias.component.html',
    styleUrls: ['./detalhar-ferias.component.scss']
})
export class DetalharFeriasComponent extends FeriasBaseComponent implements OnInit {
    private readonly chaveEstadoConsultaGerencial = 'consultaGerencialExercicioSelecionado';

    static readonly MENSAGEM_FALHA_DETALHAMENTO_ESPECIAL = 'Não foi possível recuperar o histórico da operação de férias especiais. O estado original não pode ser apresentado.';

    exercicioSelecionado: ExercicioSelecionado;
    justificativaAcumuloFerias: string[];
    veioDaConsultaGerencial = false;

    modalidadeFeriasEspeciais: TipoFeriasEspecialEnum = null;
    detalhamentoFeriasEspeciais: DetalhamentoFeriasEspeciais = null;
    carregandoDetalhamentoFeriasEspeciais = false;
    falhaDetalhamentoFeriasEspeciais: string = null;

    carrosseisParcelas: {
        ordemParcela: number;
        parcelasFerias: ParcelaFeriasEmExibicao[];
    }[] = []; //array de arrays

    parcelasFeriasCanceladas: ParcelaFeriasCanceladasEmExibicao[] = [];

    constructor(
        alertaMsgService: AlertMessageService,
        private tramitacaoService: HistoricoTramitacaoProcessoService,
        private router: Router,
        private exerciciosService: ExerciciosService
    ) {
        super(alertaMsgService);

        const navigationData = this.obterDadosNavegacao();
        this.exercicioSelecionado = navigationData || ({ parcelas: [] } as ExercicioSelecionado);
        this.veioDaConsultaGerencial = navigationData?.origemTela === 'consulta-gerencial' || this.ehFluxoConsultaGerencial();

        afterNextRender(() => {
            this.configurarCabecalhoFluxo();
            this.rolarParaTopo();
        });
    }

    ngOnInit(): void {
        if (!this.exercicioSelecionado) {
            this.exercicioSelecionado = { parcelas: [] } as ExercicioSelecionado;
        }
        if (!this.exercicioSelecionado.parcelas) {
            this.exercicioSelecionado.parcelas = [];
        }

        this.exercicioSelecionado.parcelas.forEach(parcela => {
            if (parcela.ordem === 99) {
                this.parcelasFeriasCanceladas.push({
                    dataInicio: parcela.dataInicio,
                    dataFim: parcela.dataFim,
                    quantidadeDias: parcela.quantidadeDias,
                    situacao: {
                        descricao: SituacaoParcelaFeriasEnum.CANCELADA.descricao,
                        codigoCor: SituacaoParcelaFeriasEnum.CANCELADA.extras.codigoCor
                    },
                    adiantamentoSalarial: {
                        valor: parcela.adiantamentoSalarial
                    },
                    abonoPecuniario: {
                        valor: parcela.abonoPecuniario
                    },
                    adiantamentoDecimoTerceiro: {
                        valor: parcela.adiantamentoDecimoTerceiro
                    },
                    parcelasDesconto: parcela.parcelasDesconto,
                    dataInterrupcao: parcela.dataInterrupcao,
                    motivoLegal: parcela.motivoLegal,
                    justificativaInterrupcao: parcela.justificativaInterrupcao,
                    documentoLegal: parcela.documentoLegal != null && parcela.documentoLegal != undefined ? parcela.documentoLegal.toString() : undefined,
                    dataPublicacaoDocumentoLegal: parcela.dataPublicacaoDocumentoLegal
                });
            } else {
                if (!this.carrosseisParcelas.some(carrossel => carrossel.ordemParcela === parcela.ordem)) {
                    //Adiciona um novo carrossel
                    this.carrosseisParcelas.push({
                        ordemParcela: parcela.ordem,
                        parcelasFerias: []
                    });
                }

                const gerarParcelasCarrossel: Function = parcelaFerias => {
                    //Função recursiva para gerar as parcelas

                    const carrossel = this.carrosseisParcelas.find(carrossel => carrossel.ordemParcela === parcelaFerias.ordem);
                    const situacaoParcela = SituacaoParcelaFeriasEnum.fromDesc(parcelaFerias.situacao);

                    carrossel.parcelasFerias.push({
                        ordem: parcelaFerias.ordem,
                        geracao: parcelaFerias.geracao ? parcelaFerias.geracao : 0,
                        dataInicio: parcelaFerias.dataInicio,
                        dataFim: parcelaFerias.dataFim,
                        quantidadeDias: parcelaFerias.quantidadeDias,
                        situacao: {
                            descricao: situacaoParcela?.descricao ?? parcelaFerias.situacao ?? '',
                            codigoCor: situacaoParcela?.extras?.codigoCor ?? '#a5a5a5'
                        },
                        adiantamentoSalarial: {
                            valor: parcelaFerias.adiantamentoSalarial
                        },
                        abonoPecuniario: {
                            valor: parcelaFerias.abonoPecuniario
                        },
                        adiantamentoDecimoTerceiro: {
                            valor: parcelaFerias.adiantamentoDecimoTerceiro
                        },
                        parcelasDesconto: parcela.parcelasDesconto,
                        dataInterrupcao: parcelaFerias.dataInterrupcao,
                        motivoLegal: parcelaFerias.motivoLegal,
                        justificativaInterrupcao: parcelaFerias.justificativaInterrupcao,
                        documentoLegal: parcelaFerias.documentoLegal,
                        dataPublicacaoDocumentoLegal: parcelaFerias.dataPublicacaoDocumentoLegal,
                        justificativaAcumulo: parcelaFerias.justificativaAcumulo
                    });

                    if (parcelaFerias.parcelaFilha) {
                        gerarParcelasCarrossel(parcelaFerias.parcelaFilha);
                    }

                    //ordenar as parcelas
                    carrossel.parcelasFerias.sort((a, b) => a.geracao - b.geracao);
                };

                gerarParcelasCarrossel(parcela);
            }
        });

        //ordenar as parcelas
        this.carrosseisParcelas.sort((a, b) => a.ordemParcela - b.ordemParcela);

        if (this.exercicioSelecionado.parcelas && this.exercicioSelecionado.parcelas.length > 0) {
            this.carrosseisParcelas.forEach(carrossel => {
                carrossel.parcelasFerias.forEach(parcela => {
                    if (parcela.justificativaAcumulo && (!this.justificativaAcumuloFerias || !this.justificativaAcumuloFerias.includes(parcela.justificativaAcumulo))) {
                        if (!this.justificativaAcumuloFerias) {
                            this.justificativaAcumuloFerias = [];
                        }
                        this.justificativaAcumuloFerias.push(parcela.justificativaAcumulo);
                    }
                });
            });
        }

        this.carregarDetalhamentoFeriasEspeciais();
    }

    get possuiFeriasEspeciaisComParcelas(): boolean {
        const codigo = this.modalidadeFeriasEspeciais?.id;
        return codigo === 'ACP' || codigo === 'JCP';
    }

    get exibeTituloEstadoAtualFeriasEspeciais(): boolean {
        const possuiParcelaInterrompida = this.existeParcelaInterrompida(this.exercicioSelecionado?.parcelas ?? []);

        return this.possuiFeriasEspeciaisComParcelas && !!this.exercicioAtualDetalhado && !possuiParcelaInterrompida;
    }

    get possuiFeriasEspeciaisSemParcelas(): boolean {
        const codigo = this.modalidadeFeriasEspeciais?.id;
        return codigo === 'ASP' || codigo === 'JSP';
    }

    get possuiFeriasEspeciais(): boolean {
        return this.possuiFeriasEspeciaisComParcelas || this.possuiFeriasEspeciaisSemParcelas;
    }

    get rotuloNumeroProcessoFeriasEspeciais(): string {
        if (this.modalidadeFeriasEspeciais?.id === 'JSP') {
            return 'Número do processo judicial';
        }
        if (this.modalidadeFeriasEspeciais?.id === 'ASP') {
            return 'Número do processo administrativo';
        }
        return 'Número do processo';
    }

    get rotuloFundamentacaoFeriasEspeciais(): string {
        if (this.modalidadeFeriasEspeciais?.id === 'JSP') {
            return 'Descrição resumida da sentença';
        }
        if (this.modalidadeFeriasEspeciais?.id === 'ASP') {
            return 'Justificativa das férias especiais';
        }
        return 'Fundamentação';
    }

    obterDescricaoTipoPeriodoAquisitivo(periodoAquisitivo: PeriodoAquisitivo | null | undefined): string {
        return obterDescricaoPeriodoAquisitivo(periodoAquisitivo);
    }

    obterDescricaoSituacaoExercicio(situacao: string | null | undefined): string {
        if (!situacao) {
            return 'Não informado';
        }
        return SituacaoExercicioFeriasEnum.fromId(situacao)?.descricao ?? SituacaoExercicioFeriasEnum.fromDesc(situacao)?.descricao ?? situacao;
    }

    get mensagemAlteracaoFeriasEspeciais(): string | null {
        const codigoInformado = this.exercicioSelecionado?.tipoFeriasEspecial?.trim().toUpperCase();
        const modalidadePorDescricao = TipoFeriasEspecialEnum.all.find(tipo => tipo.descricao === this.exercicioSelecionado?.descricaoTipoFeriasEspecial);
        const codigo = this.modalidadeFeriasEspeciais?.id ?? (codigoInformado === 'JMI' ? codigoInformado : null) ?? modalidadePorDescricao?.id ?? codigoInformado;

        switch (codigo) {
            case 'ASP':
                return 'ASP: Este exercício foi alterado por Férias Especiais Administrativas.';
            case 'JSP':
                return 'JSP: Este exercício foi alterado por Férias Especiais Judiciais.';
            case 'ACP':
                return 'ACP: Este exercício e suas parcelas podem ter sido alteradas por Férias Especiais Administrativas.';
            case 'JCP':
                return 'JCP: Este exercício e suas parcelas podem ter sido alteradas por Férias Especiais Judiciais.';
            case 'JMI':
                return 'JMI: Este exercício e suas parcelas podem ter sido alteradas por Férias Especiais Judiciais.';
            default:
                return null;
        }
    }

    get operacaoFeriasEspeciais(): OperacaoFeriasEspeciaisDetalhada | null {
        return this.detalhamentoFeriasEspeciais?.operacao ?? null;
    }

    get exercicioAtualDetalhado(): ExercicioDetalhadoFeriasEspeciais {
        return this.detalhamentoFeriasEspeciais?.exercicioAtual ?? null;
    }

    /**
     * Só devolve o estado original quando o backend confirmou o histórico. O estado atual nunca
     * é usado como substituto do original.
     */
    get exercicioOriginalDetalhado(): ExercicioDetalhadoFeriasEspeciais {
        if (!this.detalhamentoFeriasEspeciais?.historicoDisponivel) {
            return null;
        }
        return this.detalhamentoFeriasEspeciais.exercicioOriginal ?? null;
    }

    get historicoFeriasEspeciaisIndisponivel(): boolean {
        if (this.falhaDetalhamentoFeriasEspeciais) {
            return true;
        }
        return !!this.detalhamentoFeriasEspeciais && !this.detalhamentoFeriasEspeciais.historicoDisponivel;
    }

    get motivoHistoricoFeriasEspeciaisIndisponivel(): string {
        if (this.falhaDetalhamentoFeriasEspeciais) {
            return this.falhaDetalhamentoFeriasEspeciais;
        }
        return this.detalhamentoFeriasEspeciais?.motivoIndisponibilidadeHistorico ?? null;
    }

    get descricaoModalidadeFeriasEspeciais(): string {
        return this.detalhamentoFeriasEspeciais?.descricaoModalidade ?? this.modalidadeFeriasEspeciais?.descricao ?? null;
    }

    get textoAlternativoModalidadeFeriasEspeciais(): string {
        return this.modalidadeFeriasEspeciais?.extras?.textoAlternativo ?? null;
    }

    /**
     * Processo e fundamentação só são exibidos quando o backend os devolve ao usuário autorizado.
     */
    get exibeDadosProcessoFeriasEspeciais(): boolean {
        const operacao = this.operacaoFeriasEspeciais;
        if (this.possuiFeriasEspeciaisSemParcelas) {
            return !!operacao || !!this.exercicioAtualDetalhado;
        }
        return !!operacao?.numeroProcesso || !!operacao?.fundamentacao;
    }

    /**
     * Formata o instante da operação (`LocalDateTime` do backend) como `dd/mm/aaaa hh:mm`.
     */
    get dataOperacaoFeriasEspeciaisFormatada(): string {
        const dataOperacao = this.operacaoFeriasEspeciais?.dataOperacao;
        if (!dataOperacao) {
            return '';
        }

        const [data, hora] = dataOperacao.split('T');
        const partesData = data.split('-');
        if (partesData.length !== 3) {
            return '';
        }

        const dataFormatada = `${partesData[2]}/${partesData[1]}/${partesData[0]}`;
        return hora ? `${dataFormatada} ${hora.substring(0, 5)}` : dataFormatada;
    }

    corSituacaoParcela(situacao?: string): string {
        const situacaoParcela = this.resolverSituacaoParcela(situacao);
        return situacaoParcela?.extras?.codigoCor ?? '#a5a5a5';
    }

    obterDescricaoSituacaoParcela(situacao?: string): string {
        if (!situacao) {
            return 'Não informada';
        }
        return this.resolverSituacaoParcela(situacao)?.descricao ?? situacao;
    }

    private resolverSituacaoParcela(situacao?: string) {
        if (!situacao) {
            return null;
        }
        return SituacaoParcelaFeriasEnum.fromDesc(situacao) ?? SituacaoParcelaFeriasEnum.fromId(situacao);
    }

    private existeParcelaInterrompida(parcelas: ExercicioSelecionado['parcelas']): boolean {
        return parcelas.some(parcela => this.resolverSituacaoParcela(parcela.situacao)?.id === SituacaoParcelaFeriasEnum.INTERROMPIDA.id || (parcela.parcelaFilha != null && this.existeParcelaInterrompida([parcela.parcelaFilha])));
    }

    private carregarDetalhamentoFeriasEspeciais(): void {
        this.modalidadeFeriasEspeciais = TipoFeriasEspecialEnum.fromCodigoOuNome(this.exercicioSelecionado?.tipoFeriasEspecial);

        if (!this.possuiFeriasEspeciais) {
            return;
        }

        const idFerias = this.exercicioSelecionado?.idFerias;
        if (!idFerias) {
            this.falhaDetalhamentoFeriasEspeciais = DetalharFeriasComponent.MENSAGEM_FALHA_DETALHAMENTO_ESPECIAL;
            return;
        }

        this.carregandoDetalhamentoFeriasEspeciais = true;
        const consultaDetalhamento = this.possuiFeriasEspeciaisComParcelas ? this.exerciciosService.detalharFeriasEspeciaisComParcelas(idFerias) : this.exerciciosService.detalharFeriasEspeciaisSemParcelas(idFerias);

        consultaDetalhamento.subscribe({
            next: detalhamento => {
                this.detalhamentoFeriasEspeciais = detalhamento;
                this.falhaDetalhamentoFeriasEspeciais = null;
                this.carregandoDetalhamentoFeriasEspeciais = false;
            },
            error: () => {
                this.detalhamentoFeriasEspeciais = null;
                this.falhaDetalhamentoFeriasEspeciais = DetalharFeriasComponent.MENSAGEM_FALHA_DETALHAMENTO_ESPECIAL;
                this.carregandoDetalhamentoFeriasEspeciais = false;
            }
        });
    }

    voltar(): void {
        if (this.veioDaConsultaGerencial) {
            sessionStorage.removeItem(this.chaveEstadoConsultaGerencial);
            this.router.navigate(['/secure/consulta-gerencial']);
            return;
        }
        this.router.navigate(['/secure/gerenciar-ferias/consultar-exercicios']);
    }

    private obterDadosNavegacao(): ExercicioSelecionadoNavegacao | null {
        const navigationData = this.router.getCurrentNavigation()?.extras?.state?.data as ExercicioSelecionadoNavegacao;
        if (navigationData) {
            return navigationData;
        }

        const estadoPersistido = this.recuperarEstadoConsultaGerencial();
        if (this.ehFluxoConsultaGerencial()) {
            return estadoPersistido || history.state?.data || null;
        }

        return history.state?.data || estadoPersistido || null;
    }

    private recuperarEstadoConsultaGerencial(): ExercicioSelecionado | null {
        try {
            const estadoSerializado = sessionStorage.getItem(this.chaveEstadoConsultaGerencial);
            return estadoSerializado ? JSON.parse(estadoSerializado) : null;
        } catch {
            return null;
        }
    }

    private ehFluxoConsultaGerencial(): boolean {
        return this.router.url.includes('/secure/consulta-gerencial/');
    }

    private configurarCabecalhoFluxo(): void {
        if (this.veioDaConsultaGerencial) {
            this.alterarTituloTemplate('Consulta Gerencial');
            this.alterarTextoBreadcrumb(1, 'Consulta Gerencial');
            return;
        }

        this.alterarTituloTemplate('Gerenciar Férias');
        this.alterarTextoBreadcrumb(1, 'Gerenciar Férias - Buscar Agente Público');
    }
}
